import {Component, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {IMPDuoToneModule} from "../marketing-page.models";
import {LoggerService} from "../../common/logger.service";
import {MarketingPageUtil} from "../marketing-page-util";
import {ICartImage} from "../../cart/catalog/catalog-models";
import {CartUtil} from "../../cart/cart-util";
import {Constants} from "../../constants";

@Component({
    templateUrl: './duo-tone.component.html',
    styleUrls: ['./duo-tone.component.scss'],
    standalone: false
})
export class DuoToneComponent extends UsanaObject implements OnInit {

    pageUrl: string;
    componentData: IMPDuoToneModule;
    useLocaleOverride: boolean;
    translationRoot: string;
    textStyle: string;
    backgroundColor: string;
    backgroundColor2: string;
    buttonType: string;
    callToActionUrl: string;
    mobileImagePath: string;

    constructor(loggerService: LoggerService) {
        super(loggerService);
    }

    ngOnInit(): void {
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, this.componentData.name);
        const cartImages: ICartImage[] = MarketingPageUtil.getCartImagesFromModule(this.componentData);
        this.mobileImagePath = CartUtil.getCartImagePathByType(cartImages, Constants.IMAGE_TYPE_MOBILE);
        this.buttonType = MarketingPageUtil.getButtonTypeClass(this.componentData.buttonType);
        this.backgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor);
        this.backgroundColor2 = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor2);
        this.textStyle = MarketingPageUtil.getTextStyleClass(this.componentData.textStyle);
        this.callToActionUrl = this.componentData.countryDetails[0].callToActionUrl;
    }

    callToActionClick() {
        window.location.href = this.callToActionUrl;
    }
}
